import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import {getComponentName} from '../../common/utils/namespace';
import {createNamespace, addUnit} from '../../common/utils';

var _createNamespace = createNamespace('skeleton'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

var DEFAULT_ROW_WIDTH = '100%';
var DEFAULT_LAST_ROW_WIDTH = '60%';
export default {
    name: getComponentName('Skeleton'),
    data: function data() {
        return {};
    },
    props: {
        title: Boolean,
        avatar: Boolean,
        row: {
            type: [Number, String],
            default: 0
        },
        loading: {
            type: Boolean,
            default: true
        },
        animate: {
            type: Boolean,
            default: true
        },
        avatarSize: {
            type: String,
            default: '2em'
        },
        avatarShape: {
            type: String,
            default: 'round'
        },
        titleWidth: {
            type: [Number, String],
            default: '40%'
        },
        rowWidth: {
            type: [Number, String, Array],
            default: DEFAULT_ROW_WIDTH
        }
    },
    render: function render() {
        var h = arguments[0];
        var props = this.$props,
            slots = this.$slots;

        if (!props.loading) {
            return slots.default;
        }

        function Title() {
            if (props.title) {
                return h('h3', {
                    class: b('title'),
                    style: {
                        width: addUnit(props.titleWidth)
                    }
                });
            }
        }

        function Rows() {
            var Rows = [];
            var rowWidth = props.rowWidth;

            function getRowWidth(index) {
                if (rowWidth === DEFAULT_ROW_WIDTH && index === +props.row - 1) {
                    return DEFAULT_LAST_ROW_WIDTH;
                }

                if (Array.isArray(rowWidth)) {
                    return rowWidth[index];
                }

                return rowWidth;
            }

            for (var i = 0; i < props.row; i++) {
                Rows.push(
                    h('div', {
                        class: b('row'),
                        style: {
                            width: addUnit(getRowWidth(i))
                        }
                    })
                );
            }

            return Rows;
        }

        function Avatar() {
            if (props.avatar) {
                var size = addUnit(props.avatarSize);
                return h('div', {
                    class: b('avatar', props.avatarShape),
                    style: {
                        width: size,
                        height: size
                    }
                });
            }
        }

        return h(
            'div',
            {
                class: b({
                    animate: props.animate
                })
            },
            [
                Avatar(),
                h(
                    'div',
                    {
                        class: b('content')
                    },
                    [Title(), Rows()]
                )
            ]
        );
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
